import { FC, memo } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TaskPropertyRow } from '../TaskPropertyRow';
import { ReactComponent as SparkleIcon } from '../../../assets/scheduler/sparkle.svg';

interface TaskAiNoteSectionProps {
  value: string;
  isReadOnly?: boolean;
  onChange: (value: string) => void;
}

export const TaskAiNoteSection: FC<TaskAiNoteSectionProps> = memo(
  ({ value, isReadOnly = false, onChange }) => {
    const { t } = useTranslation();

    return (
      <TaskPropertyRow icon={<SparkleIcon className="task-detail-modal__icon" />}>
        <TextField
          placeholder={t('task.modal.aiNotePlaceholder')}
          multiline
          minRows={1}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          variant="standard"
          className="task-detail-modal__desc-textarea"
          disabled={isReadOnly}
          fullWidth
        />
      </TaskPropertyRow>
    );
  }
);

TaskAiNoteSection.displayName = 'TaskAiNoteSection';
